// import React, { useState, useRef } from "react";
// import ViewMap from "./Views/ViewMap.jsx";
// import useMapData from "./hooks/useMapData.jsx";
// import shpwrite from "shp-write-pure"; // For Shapefile export
// import tokml from "geojson-to-kml";
// import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
// import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from "@mui/material";
// import IPDCToastMessageResult from "../../../../../components/Controls/IPDCToastMessageResult.jsx";
// import ParkList from "../../../Shared/PreRenderedComponents/ParkList.jsx";
// import *as turf from "@turf/turf";

// const featureTypes = [
//   { key: "park", label: "Park" },
//   { key: "BLOCKs", label: "Block" },
//   { key: "PARCELs", label: "Parcel" },
//   { key: "buildings", label: "Building" },
//   { key: "roads", label: "Road" },
//   { key: "greenareas", label: "Green Area" },
//   { key: "powers", label: "Power supply" },
//   { key: "communications", label: "Communication" },
//   { key: "storages", label: "Storage" },
//   { key: "wastedisposals", label: "Waste Disposal" },
//   { key: "waters", label: "Water supply" },
//   { key: "gcps", label: "GCPs" },
//   { key: "surveyDatas", label: "Survey Point" },
//   { key: "plans", label: "Plan" },
// ];

// export default function ExportDataPage() {
//   const mapRef = useRef(null); // Use useRef for map instance
//   const [selectedPark, setSelectedPark] = useState(null);
//   const [selectedFeatureType, setFeatureType] = useState(featureTypes[0].key);
//   const [selectedFormat, setSelectedFormat] = useState("GeoJSON");
//   const [responseMessage, setResponseMessage] = useState("");
//   const [messageType, setMessageType] = useState("info");
//   const data = useMapData();

//   const exportAsGeojson = async resultToExport => {
//     // Convert the result to a GeoJSON string
//     const geojson = JSON.stringify(resultToExport);

//     // Option 1: Download the file
//     const blob = new Blob([geojson], { type: "application/json" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = selectedFeatureType + ".geojson";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     return selectedFeatureType + ".geojson";
//   };
//   const exportAsShape = async resultToExport => {
//     try {
//       const options = {
//         outputType: "blob", // Specify output type here
//       };

//       const { compression = "STORE", ...restOptions } = options; // Set default 'STORE' for compression

//       const shapefileData = await shpwrite.zip(resultToExport, {
//         compression,
//         ...restOptions,
//       });
//       if (shapefileData) {
//         console.log(shapefileData);
//         // Option 1: Download the file
//         const blob = new Blob([shapefileData], { type: "application/json" });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = selectedFeatureType + ".zip";
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         URL.revokeObjectURL(url);
//         return selectedFeatureType + ".zip";
//       } else {
//         return null;
//       }
//     } catch (err) {
//       console.log(err);
//       return null;
//     }
//   };
//   const exportAsKml = async resultToExport => {
//     try {
//       const kmlNameDescription = tokml(resultToExport);
//       // Option 1: Download the file
//       const blob = new Blob([kmlNameDescription], { type: "application/json" });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = selectedFeatureType + ".kml";
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//       return selectedFeatureType + ".kml";
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   const filterParkAndFeatureFirst = async (parkId, featureType) => {
//     if (!data) return null;
  
//     // Find the park boundary
//     const park = data['park'].features.find(park => park?.id === parkId);
//     if (!park) {
//       console.warn('Park not found with id:', parkId);
//       return null;
//     }
//     const parkBoundary = park.geometry;
  
//     // Convert park boundary to a turf polygon if it's not already in the correct format
//     const parkPolygon = turf.polygon(parkBoundary.coordinates);
  
//     // Normalize the feature type for lookup
//     const normalizedFeatureType = featureType?.toLowerCase();
  
//     // Filter features that are within the park
//     const featuresInPark = data[normalizedFeatureType]?.features.filter(feature => {
//       // Convert the feature's geometry to a turf point or polygon depending on its type
//       let featureGeometry;
//       if (feature.geometry.type === 'Point') {
//         featureGeometry = turf.point(feature.geometry.coordinates);
//       } else if (feature.geometry.type === 'Polygon') {
//         featureGeometry = turf.polygon(feature.geometry.coordinates);
//       } else {
//         // Handle other geometry types if necessary
//         console.warn('Unsupported geometry type:', feature.geometry.type);
//         return false;
//       }
  
//       // Check if the feature is within or intersects the park boundary
//       return turf.booleanWithin(featureGeometry, parkPolygon);
//     });
  
//     // If no features are found within the park, return null or an empty array as needed
//     return featuresInPark?.length > 0 ? { type: 'FeatureCollection', features: featuresInPark } : null;
//   };
//   const handleSubmit = async e => {
//     e.preventDefault();
//     try {
//       if (selectedPark && selectedFeatureType && selectedFormat) {
//         //console.log(selectedFeatureType?.toLowerCase(), selectedFormat);
//         const resultToExport = await filterParkAndFeatureFirst(selectedPark?.id, selectedFeatureType);
        
//         console.log("features in park", resultToExport);
//         //return;
//         if (!resultToExport) {
//           setResponseMessage("Can't export right now, please wait and try again or there is no data to export!");
//           setMessageType("info");
//           return;
//         }
//         if (selectedFormat === "GeoJSON") {
//           const exportedAs = await exportAsGeojson(resultToExport);
//           setResponseMessage('Successfully exported as "' + exportedAs + '" in your default download folder.');
//           setMessageType("success");
//           return;
//         } else if (selectedFormat === "Shapefile") {
//           console.log("Shape file xport started");
//           const exportedAs = await exportAsShape(resultToExport);
//           if (exportedAs) {
//             setResponseMessage('Successfully exported as "' + exportedAs + '" in your default download folder.');
//             setMessageType("success");
//           } else {
//             setResponseMessage("Unable to export to shape because the features are in use, please try again later.");
//             setMessageType("error");
//           }
//         } else if (selectedFormat === "kml") {
//           const exportedAs = await exportAsKml(resultToExport);
//           setResponseMessage('Successfully exported as "' + exportedAs + '" in your default download folder.');
//           setMessageType("success");
//           return;
//         }
//       }
//     } catch (error) {
//       setResponseMessage("An error occurred: " + error.message);
//       setMessageType("error");
//       console.error(error);
//     }
//   };

//   return (
//     <>
//       <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark, p: 2 }} elevation={3}>
//         {" "}
//         {/* Added padding */}
//         <Typography variant="h5" gutterBottom align="center">
//           Export Spatial Data
//         </Typography>
//         <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//             <ParkList selectedPark={selectedPark} setSelectedPark={setSelectedPark} isRequired={true} />
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel id="featureType-label">Feature Type</InputLabel>
//                 <Select
//                   labelId="featureType-label"
//                   id="featureType"
//                   value={selectedFeatureType}
//                   label="Feature Type"
//                   onChange={e => setFeatureType(e.target.value)}
//                 >
//                   {featureTypes.map(type => (
//                     <MenuItem key={type.key} value={type.key}>
//                       {type.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel id="format-label">Format</InputLabel>
//                 <Select
//                   labelId="format-label"
//                   id="format"
//                   value={selectedFormat}
//                   label="Format"
//                   onChange={e => setSelectedFormat(e.target.value)}
//                 >
//                   <MenuItem value="GeoJSON">GeoJSON</MenuItem>
//                   <MenuItem value="Shapefile">Shapefile</MenuItem>
//                   <MenuItem value="kml">KML</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <Button type="submit" variant="contained" color="primary">
//                 Export
//               </Button>
//             </Grid>
//           </Grid>
//         </Box>
//         {responseMessage && <IPDCToastMessageResult message={responseMessage} type={messageType} />}
//       </Paper>
//       <ViewMap ref={mapRef} isEditable={false} showLegend={false} />
//     </>
//   );
// }

////////////////////////////////////////////

import React, { useContext, useState, useRef } from "react";
import ViewMap from "./Views/ViewMap.jsx";
import useMapData from "./hooks/useMapData.jsx";
import shpwrite from "shp-write-pure";
import tokml from "geojson-to-kml";
import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from "@mui/material";
import IPDCToastMessageResult from "../../../../../components/Controls/IPDCToastMessageResult.jsx";
import ParkList from "../../../Shared/PreRenderedComponents/ParkList.jsx";
import * as turf from "@turf/turf";
import { MapDataContext } from "./MapData/MapDataContext.js";

const featureTypes = [
  { key: "park", label: "Park" },
  { key: "blocks", label: "Block" },
  { key: "parcels", label: "Parcel" },
  { key: "sheds", label: "Sheds" },
  { key: "buildings", label: "Building" },
  { key: "roads", label: "Road" },
  { key: "greenAreas", label: "Green Area" },
  { key: "powers", label: "Power supply" },
  { key: "communications", label: "Communication" },
  { key: "storages", label: "Storage" },
  { key: "wasteDisposals", label: "Waste Disposal" },
  { key: "waters", label: "Water supply" },
  { key: "gcps", label: "GCPs" },
  { key: "surveyDatas", label: "Survey Point" },
  { key: "plans", label: "Plan" },
];

export default function ExportDataPage() {
  const mapRef = useRef(null);
  const [selectedPark, setSelectedPark] = useState(null);
  const [selectedFeatureType, setFeatureType] = useState(featureTypes[0].key);
  const [selectedFormat, setSelectedFormat] = useState("GeoJSON");
  const [responseMessage, setResponseMessage] = useState("");
  const [messageType, setMessageType] = useState("info");

  // In ExportDataPage.jsx (temporarily add this)
// console.log("Current MapDataContext:", useContext(MapDataContext));

  const data = useContext(MapDataContext);

  const exportAsGeojson = async (resultToExport) => {
    const geojson = JSON.stringify(resultToExport);
    const blob = new Blob([geojson], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${selectedFeatureType}.geojson`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return `${selectedFeatureType}.geojson`;
  };
  
  const exportAsShape = async (resultToExport) => {
  try {
    const shapefileDataBase64 = await shpwrite.zip(resultToExport, {
      compression: "STORE",
    });

    if (shapefileDataBase64) {
      // Convert base64 to binary
      const byteCharacters = atob(shapefileDataBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${selectedFeatureType}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      return `${selectedFeatureType}.zip`;
    }
    return null;
  } catch (err) {
    console.error("Shapefile export error:", err);
    return null;
  }
};

  const exportAsKml = async (resultToExport) => {
    try {
      const kml = tokml(resultToExport);
      const blob = new Blob([kml], { type: "application/vnd.google-earth.kml+xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${selectedFeatureType}.kml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      return `${selectedFeatureType}.kml`;
    } catch (err) {
      console.error("KML export error:", err);
      return null;
    }
  };
  
 

const filterParkAndFeatureFirst = (parkId, featureType) => {
  if (!data || !parkId || !featureType) {
    console.warn("Missing required data:", { data, parkId, featureType });
    return null;
  }

  // Get park geometry
  const park = data.park?.features?.find(p => p?.id === parkId);
  if (!park || !park.geometry) {
    console.warn("Park not found or missing geometry for id:", parkId);
    return null;
  }

  // Helper: extract valid coordinates for Polygon/MultiPolygon
  const getValidPolygonCoords = (geometry) => {
    if (!geometry || !geometry.coordinates) return null;

    let coords = null;
    if (geometry.type === "Polygon") {
      coords = geometry.coordinates;
    } else if (geometry.type === "MultiPolygon") {
      coords = geometry.coordinates[0]; // first polygon
    } else {
      return null;
    }

    // Ensure we have an array of rings
    if (!Array.isArray(coords) || !Array.isArray(coords[0])) return null;

    // Close the ring if needed
    coords = coords.map(ring => {
      if (ring.length >= 3) {
        const first = ring[0];
        const last = ring[ring.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
          ring = [...ring, first];
        }
      }
      return ring;
    });

    // Must have at least 4 points in the outer ring
    if (coords[0].length < 4) return null;

    return coords;
  };

  // Get valid park polygon
  const parkCoords = getValidPolygonCoords(park.geometry);
  if (!parkCoords) {
    console.warn("Invalid park polygon:", park.geometry);
    return null;
  }
  const parkPolygon = turf.polygon(parkCoords);

  // Check if feature type exists in data
  if (!data[featureType]?.features) {
    console.warn(`Feature type "${featureType}" not found in data`);
    return null;
  }

  // Filter features inside park
  const featuresInPark = data[featureType].features.filter(feature => {
    if (!feature.geometry) return false;

    try {
      let featureGeometry = null;

      if (feature.geometry.type === "Point") {
        featureGeometry = turf.point(feature.geometry.coordinates);
      } else {
        const coords = getValidPolygonCoords(feature.geometry);
        if (!coords) return false; // skip invalid polygons
        featureGeometry = turf.polygon(coords);
      }

      return turf.booleanWithin(featureGeometry, parkPolygon);
    } catch (error) {
      console.warn("Error processing feature:", feature.id, error);
      return false;
    }
  });

  return featuresInPark.length > 0
    ? { type: "FeatureCollection", features: featuresInPark }
    : null;
};

////////////////////////
const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log('Available data:', data); // Add this
    console.log("selected park",selectedPark.id)
    console.log("selected feature:",selectedFeatureType)
    console.log("selected format:",selectedFormat)
    
    console.log(data)
    setResponseMessage("");
    
    if (!selectedPark || !selectedFeatureType || !selectedFormat) {
      setResponseMessage("Please select all required fields");
      setMessageType("error");
      return;
    }

    try {
      const resultToExport = filterParkAndFeatureFirst(selectedPark.id, selectedFeatureType);
      
      if (!resultToExport) {
        setResponseMessage("No data found to export for the selected criteria");
        setMessageType("info");
        return;
      }

      let exportedAs;
      switch (selectedFormat) {
        case "GeoJSON":
          exportedAs = await exportAsGeojson(resultToExport);
          break;
        case "Shapefile":
          exportedAs = await exportAsShape(resultToExport);
          break;
        case "kml":
          exportedAs = await exportAsKml(resultToExport);
          break;
        default:
          throw new Error("Unsupported export format");
      }

      if (exportedAs) {
        setResponseMessage(`Successfully exported as "${exportedAs}"`);
        setMessageType("success");
      } else {
        setResponseMessage("Export failed - please try again");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Export error:", error);
      setResponseMessage(`Error: ${error.message}`);
      setMessageType("error");
    }
  };

  return (
    <>
      <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark, p: 2 }} elevation={3}>
        <Typography variant="h5" gutterBottom align="center">
          Export Spatial Data
        </Typography>
        <Box 
          component="form" 
          onSubmit={handleSubmit} 
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ParkList 
                selectedPark={selectedPark} 
                setSelectedPark={setSelectedPark} 
                isRequired={true} 
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="featureType-label">Feature Type</InputLabel>
                <Select
                  labelId="featureType-label"
                  id="featureType"
                  value={selectedFeatureType}
                  label="Feature Type"
                  onChange={(e) => setFeatureType(e.target.value)}
                >
                  {featureTypes.map((type) => (
                    <MenuItem key={type.key} value={type.key}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="format-label">Format</InputLabel>
                <Select
                  labelId="format-label"
                  id="format"
                  value={selectedFormat}
                  label="Format"
                  onChange={(e) => setSelectedFormat(e.target.value)}
                >
                  <MenuItem value="GeoJSON">GeoJSON</MenuItem>
                  <MenuItem value="Shapefile">Shapefile</MenuItem>
                  <MenuItem value="kml">KML</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Export
              </Button>
            </Grid>
          </Grid>
        </Box>
        {responseMessage && (
          <IPDCToastMessageResult message={responseMessage} type={messageType} />
        )}
      </Paper>
      <ViewMap ref={mapRef} isEditable={false} showLegend={false} />
    </>
  );
}
///////////////////////////////////////////////